import React from "react";
import { connect } from "react-redux";
import "./_MemoryFilter.scss";
import { toggleMemoryCollections } from "../../redux/actions";

class MemoryFilter extends React.Component {
  renderMemoryFilters = () => {
    const { memories, selectedMemoryCollections } = this.props;
    if (memories && memories.items) {
      return (
        <div className="collection-filters">
          {memories.items.map((item) => {
            const buttonClass = selectedMemoryCollections.includes(item.sys.id)
              ? "collection-button active"
              : "collection-button";
            return (
              <button
                className={buttonClass}
                key={item.sys.id}
                onClick={() => this.props.toggleMemoryCollections(item.sys.id)}
              >
                {item.fields.title}
              </button>
            );
          })}
        </div>
      );
    }
  };

  render() {
    const { memoryOverlayCollectionTitleText } = this.props;

    return (
      <div className="memory-filter">
        <span className="subtitle">{memoryOverlayCollectionTitleText}</span>
        {this.renderMemoryFilters()}
      </div>
    );
  }
}

const mapStateToProps = ({ necklace, configuratorPageNecklace }) => {
  const { memories, selectedMemoryCollections } = necklace;
  const { memoryOverlayCollectionTitleText } = configuratorPageNecklace;

  return {
    memories,
    selectedMemoryCollections,
    memoryOverlayCollectionTitleText,
  };
};

export default connect(mapStateToProps, {
  toggleMemoryCollections,
})(MemoryFilter);
